module.exports = __webpack_public_path__ + "img/frame-login-mb.9722e709.webp";